import { useEffect } from 'react';
import { connect } from 'react-redux';
import * as ac from './action_creators';

/**
 * Getters are react component that if imported and added to
 * a React app they will make dispatch actions that fetches
 * the needed data from the backend.
 */

const getterCreator = (actionCreator) => {
  const Getter = ({ getFunc, parameters }) => {
    useEffect(() => {
      getFunc(parameters);
    }, []);
    return <></>;
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      getFunc: (parameters) => dispatch(actionCreator(parameters)),
    };
  };

  return connect(null, mapDispatchToProps)(Getter);
};
/** @type {any} */
export const SpicyTagsGetter = getterCreator(ac.getSpicyTagsAC);
